/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {BreakpointObserver} from "@angular/cdk/layout";
import {Overlay} from "@angular/cdk/overlay";
import {ChangeDetectorRef, Component, OnInit, ViewChild} from "@angular/core";
import {ActivatedRoute, Router, RouterOutlet} from '@angular/router';
import {Meta, Title} from "@angular/platform-browser";

import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";

import {environment} from '../../environments/environment';

import {fadeAnimation} from "../platform/base/library/fade-animation";
import {SessionService} from "../platform/base/services/session.service";
import {ResponsiveComponent} from "../platform/base/components/responsive.component";

import {PaymentService} from "./payment/payment.service";

import {GuestsComponent} from "./guests/guests.component";
import {MessageDialogComponent} from "./base/components/message-dialog/message-dialog.component";

import {IErrorObject} from "../../../types/platform/universe";

import {AuthLevel} from "../../../types/aig/universe";

import {TranslateService} from '@ngx-translate/core';
import {GuestsService} from "./guests/guests.service";
import {Guests2Service} from "./guests2/guests2.service";

/*
*
*
*
* */
@Component({
	selector: "aigia-root",
	templateUrl: "./aigia.component.html",
	styleUrls: ["./aigia.component.css"],
	animations: [fadeAnimation], // register the animation,
})

export class AigiaComponent extends ResponsiveComponent implements OnInit {

	public dark: boolean = true;
	public company: string;
	public params: any = {};

	public isSubscribe: boolean = false;
	public isAccounting: boolean = false;

	public endPoint: string;
	public device: string;

	@ViewChild(GuestsComponent) protected guestsComponent: GuestsComponent;

	constructor(
		protected session: SessionService,
		private accountService: GuestsService,
		//private accountService: Guests2Service,		// todo:guests2
		private stripeService: PaymentService,
		protected overlay: Overlay,
		protected snackbar: MatSnackBar,
		protected change: ChangeDetectorRef,
		protected matDialog: MatDialog,
		protected breakpointObserver: BreakpointObserver,
		private router: Router,
		protected route: ActivatedRoute,
		protected title: Title,
		protected meta: Meta,
		public translate: TranslateService,
	) {
		super(session, breakpointObserver);

		// i18n
		translate.addLangs(['en', 'ja']);
		const Lang = localStorage.getItem("language");
		if (Lang) {
			translate.use(Lang);
		} else {
			const defaultLang = navigator.language.match(/en|ja/) ? navigator.language : 'en';
			localStorage.setItem("language", defaultLang);
			translate.use(defaultLang);
		}

		this.device = "";
		this.endPoint = environment.endPoint;
	}

	public setLanguage(Lang: string): void {
		localStorage.setItem("language", Lang);
		this.translate.use(Lang)
	}

	public langToName(lang: string): string {
		let result = "";
		switch (lang) {
			case "ja":
				result = "日本語";
				break;
			case "en":
				result = "English";
				break;
		}
		return result;
	}

	/**
	 * エラーダイアログ
	 *
	 * @returns none
	 */
	private errorDialog(error: IErrorObject, callback: (result: any) => void = (error: IErrorObject) => {}): void {
		if (error) {
			if (error.code === 1) {
				this.router.navigate(['/']);
			} else {
				const dialog: MatDialogRef<any> = this.matDialog.open(MessageDialogComponent, {
					width: "30%",
					minWidth: "320px",
					height: "fit-content",
					data: {content: {title: "Error.", message: error.message, tag: error.tag}},
					disableClose: true,
				});

				dialog.afterClosed().subscribe((result: any): void => {
					callback(result);
				});
			}
		}
	}

	/**
	 *
	 */
	public prepareRoute(outlet: RouterOutlet): any {
		return (outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation);
	}

	/**
	 * @returns none
	 */
	public setDescription(meta: { title: string, description: any[] }): void {
		meta.description.forEach((each_description) => {
			this.meta.updateTag(each_description);
		})
	}

	/**
	 *
	 * @returns none
	 */
	public ngOnInit(): void {
		super.ngOnInit();
		this.InitProgress();
		this.Progress(true);
		this.getSession((error: IErrorObject, session: object): void => {
			if (!error) {
				this.route.queryParams.subscribe(params => {
					this.params = params;

					if (params.token) {
						this.session.put({token: params.token}, () => {
						})
					}

					this.company = "";
					if (params.c) {
						this.company = params.c;
					}

					this.isHandsetPortrait.subscribe((layoutDetector: any) => {
						if (layoutDetector.matches) {
							this.device = "handset";
						}
					});

					this.isTabletPortrait.subscribe((layoutDetector: any) => {
						if (layoutDetector.matches) {
							this.device = "tablet";
						}
					});

					this.isWeb.subscribe((layoutDetector: any) => {
						if (layoutDetector.matches) {
							this.device = "desktop";
						}
					});

					this.stripeService.is_subscribe((error: IErrorObject, result: boolean) => {
						if (!error) {
							this.isSubscribe = result;
						} else {
							this.errorDialog(error);
						}
					});


					// ログインしているアカウントが請求書支払いのスタジオの所属アカウントかチェック
					if (this.currentSession.user_id) {

						this.isAccounting = false;
						this.accountService.belongs(this.currentSession.user_id, (error: IErrorObject, accounts: any[]) => {
							if (!error) {
								accounts.forEach((account) => {
									if (account.content.accounting) {
										this.isAccounting = account.content.accounting;
									}
								});
							} else {
								this.errorDialog(error);
							}
						});
					}
				});
			}
			this.Progress(false);
		});
	}

	/**
	 *
	 * @param data
	 */
	public onRegist(data: any): void { //
	}

	/**
	 *
	 * @param data
	 */
	public onPassword(data: any): void { //
	}

	/**
	 *
	 * @param data
	 */
	public onLogin(data: any): void {
		location.reload();
	}

	/**
	 *
	 * @param data
	 */
	public onLogout(data: any): void {
		location.reload();
	}

	/**
	 * @returns none
	 */
	public onUpdateAvatar(): void {
		this.onComplete({type: "", value: null});
	}

	/**
	 *
	 * @param progress
	 */
	public onProgressed(progress: any): void {
		this.Progress(progress);
	}

	/**
	 *
	 * @param event
	 */
	public onComplete(event: any): void {
		switch (event.type) {
			case "error" :
				this.errorDialog(event.value);
				break;
			default:
		}
	}

	/**
	 *
	 */
	public side(menu_select: string): string {
		let class_side: string = "side-menu-item";

		if (menu_select === this.router.url) {
			class_side = "side-menu-item-select";
		}

		if (this.device !== 'desktop') {
			class_side += " menu-sp"
		}
		return class_side;
	}

	public authIs(level: string): boolean {
		let result: boolean = false;     // public
		switch (level) {
			case "system":
				result = (this.auth <= AuthLevel.system);
				break;
			case "manager":
				result = (this.auth <= AuthLevel.manager);
				break;
			case "company":
				result = (this.auth <= AuthLevel.company);
				break;
			case "studio":
				result = (this.auth <= AuthLevel.studio);
				break;
			case "trainer":
				result = (this.auth <= AuthLevel.trainer);
				break;
			case "user":
				result = (this.auth <= AuthLevel.user);
				break;
			case "public":
				result = (this.auth <= AuthLevel.public);
				break;
			default:
		}
		return result;
	}


	public authEq(level: string): boolean {
		let result: boolean = false;     // public
		switch (level) {
			case "system":
				result = (this.auth === AuthLevel.system);
				break;
			case "manager":
				result = (this.auth === AuthLevel.manager);
				break;
			case "company":
				result = (this.auth === AuthLevel.company);
				break;
			case "studio":
				result = (this.auth === AuthLevel.studio);
				break;
			case "trainer":
				result = (this.auth === AuthLevel.trainer);
				break;
			case "user":
				result = (this.auth === AuthLevel.user);
				break;
			case "public":
				result = (this.auth === AuthLevel.public);
				break;
			default:
		}
		return result;
	}

	//public subscribeIs(): boolean {
	//	return this.isSubscribe;
	// }
}
